// extracted by mini-css-extract-plugin
export default {"tooltip":"oS-z","arrow":"pS-z"};